'use client';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#1a1a2e',
          color: '#e0e0e0',
          fontFamily: 'system-ui, sans-serif',
        }}
      >
        <div
          style={{
            textAlign: 'center',
            padding: '2rem',
            border: '1px solid #333',
            borderRadius: '8px',
            maxWidth: '420px',
          }}
        >
          <h2 style={{ margin: '0 0 0.5rem' }}>Something went wrong</h2>
          <p style={{ opacity: 0.7, fontSize: '0.875rem' }}>
            {error.message || 'An unexpected error occurred.'}
          </p>
          {error.digest && (
            <p style={{ opacity: 0.4, fontSize: '0.75rem', fontFamily: 'monospace' }}>
              digest: {error.digest}
            </p>
          )}
          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
            <button
              onClick={reset}
              style={{
                padding: '0.5rem 1rem',
                border: '1px solid #555',
                borderRadius: '4px',
                background: 'transparent',
                color: '#e0e0e0',
                cursor: 'pointer',
              }}
            >
              Try again
            </button>
            <button
              onClick={() => {
                // In app mode the slug is the first path segment; preserve it.
                const seg = window.location.pathname.split('/').filter(Boolean)[0];
                const isApp = window.location.hostname.startsWith('app.');
                window.location.href = isApp && seg ? `/${seg}/login` : '/login';
              }}
              style={{
                padding: '0.5rem 1rem',
                border: 'none',
                borderRadius: '4px',
                background: 'transparent',
                color: '#8888cc',
                cursor: 'pointer',
              }}
            >
              Return to login
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
